export default {
    availableonTitle: "متوفر على",
    availableonPart: `
    استمتع بمحتوى حصري ومميز بجودة عالية عبر أي جهاز إلكتروني متوفر لديك من القائمة أدناه
    `,
};